// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QDuZv","label":"styles_label__2IrpV"};